/* v8 ignore start */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './themes/WidgetSettingRowLight.css';
import Checkbox from 'zignal-landscape/lib/Checkbox';
import classnames from 'classnames';
import WidgetSettingComponent from './WidgetSettingComponent';
import themeable from 'zignal-landscape/lib/themeable';
import map from 'lodash/map';
import ToolTip from 'zignal-landscape/lib/ToolTip';
import Label from 'zignal-landscape/lib/Label';
import InformationIcon from 'zignal-landscape/lib/Icon/InformationIcon';

const WiddgetSettingRow = (props) => {
  const {
    key,
    header,
    value,
    selected,
    includeAll,
    doNotDisplay,
    componentType
  } = props.rowProps;

  const {
    smartFilters,
    profileOptions,
    setSetting,
    setSelectedCols,
    timezone,
    datePickerMinDate
  } = props;
  const secondColClassNames = {
    [styles.secondColumn]: true,
    [styles.headerColumn]: true,
    [styles.secondColumnWithoutCheckbox]: key.includes('candidate'),
    [styles.notselected]: !selected,
  };

  const thirdColClassNames = {
    [styles.thirdColumn]: true,
    [styles.thirdColumnWithoutCheckbox]: key.includes('candidate'),
    [styles.notselected]: !selected,
  };

  const lastColumnClassName = {
    [styles.lastColumn]: true,
    [styles.notselected]: !selected,
  };

  const profileToolTipText = (isMulti) => `This will only apply to widgets with a
  ${isMulti === false? 'single dataset': 'multi datasets' }.`;
  return (
    <React.Fragment>
      <div className={styles.firstColumn} />
      <div className={classnames(secondColClassNames)}>
        {header}
        { componentType.includes('select') &&
          <ToolTip
            position="top"
            tooltipText={profileToolTipText(componentType.includes('multi'))}
            width={300}
          >
            <span className={styles.tooltipIcon}><InformationIcon /></span>
          </ToolTip>
        }
      </div>
      <div className={classnames(thirdColClassNames)}>
        { componentType === 'select-multi' &&
          <React.Fragment>
            <Checkbox
              id={`chk_include_all${key}`}
              name={`chk_include_all${key}`}
              data-cy={`chk_IncludeAll${key}`}
              checked={includeAll}
              onChange={() => setSetting({name:key, property: 'includeAll', value: map(profileOptions, 'value')})}
            />
            <Label htmlFor={`chk_include_all${key}`} inline>
              <span className={styles.checkboxLabelSmall}>Include All</span>
            </Label>
          </React.Fragment>
        }
        { (componentType === 'daterangepicker' || componentType === 'smartfilter') &&
          <React.Fragment>
            <Checkbox
              id={`chk_do_not_dispaly_${key}`}
              name={`chk_do_not_dispaly_${key}`}
              data-cy={`chk_do_not_dispaly_${key}`}
              checked={doNotDisplay}
              onChange={() => setSetting({name:key, property: 'doNotDisplay'})}
            />
            <Label htmlFor={`chk_do_not_dispaly_${key}`} inline>
              <span className={styles.checkboxLabelSmall}>Do Not Display</span>
            </Label>
          </React.Fragment>
        }
      </div>
      <div className={styles.firstColumn}>
        <Checkbox
          id={`chk_${key}`}
          data-cy={`chk_select_${key}`}
          name={key}
          checked={selected}
          onChange={() => setSelectedCols({name: key})}
        />
      </div>
      <div data-cy={`bulk_edit_widget_setting_component_${key}`} className={classnames(lastColumnClassName)}>
        <WidgetSettingComponent
          type={componentType}
          colName={key}
          settingValue={value}
          selected={selected}
          profileOptions={profileOptions}
          smartFilters={smartFilters}
          setSetting={setSetting}
          timezone={timezone}
          datePickerMinDate={datePickerMinDate}
        />
      </div>
    </React.Fragment>
  );
};

WiddgetSettingRow.propTypes = {
  profileOptions: PropTypes.array,
  smartFilters: PropTypes.array,
  setSetting: PropTypes.func,
  setSelectedCols: PropTypes.func,
  rowProps: PropTypes.object,
  timezone: PropTypes.string.isRequired,
  datePickerMinDate: PropTypes.object,
};

export default themeable(WiddgetSettingRow);
